var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateEvents(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 302,
    viewBox: "0 0 412 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203.944 240.956C282.81 240.956 346.744 238.041 346.744 234.446C346.744 230.85 282.81 227.935 203.944 227.935C125.077 227.935 61.1436 230.85 61.1436 234.446C61.1436 238.041 125.077 240.956 203.944 240.956Z",
    fill: "#D6E3EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.877 15H83.8771C76.4104 15 70.3438 21.0459 70.3438 28.487V194.384C70.3438 201.825 76.4104 207.871 83.8771 207.871H322.877C330.344 207.871 336.41 201.825 336.41 194.384V28.487C336.477 21.0459 330.41 15 322.877 15Z",
    fill: "#898B8E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8771 197.905C81.9438 197.905 80.3438 196.31 80.3438 194.384V28.4871C80.3438 26.5603 81.9438 24.9658 83.8771 24.9658H322.877C324.81 24.9658 326.41 26.5603 326.41 28.4871V194.384C326.41 196.31 324.81 197.905 322.877 197.905H83.8771Z",
    fill: "#5B5B5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8771 195.912C83.0104 195.912 82.3438 195.247 82.3438 194.384V28.4871C82.3438 27.6234 83.0104 26.959 83.8771 26.959H322.877C323.744 26.959 324.41 27.6234 324.41 28.4871V194.384C324.41 195.247 323.744 195.912 322.877 195.912H83.8771Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M324.477 50.9432V28.4871C324.477 27.6234 323.81 26.959 322.944 26.959H83.8771C83.0104 26.959 82.3438 27.6234 82.3438 28.4871V50.9432H324.477Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.61 207.87H95.0771V235.841H105.61V207.87Z",
    fill: "#5B5B5E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M311.677 207.87H301.144V235.841H311.677V207.87Z",
    fill: "#5B5B5E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M322.877 15H83.8771C76.4104 15 70.3438 21.0459 70.3438 28.487V30.8123C70.3438 23.3712 76.4104 17.3253 83.8771 17.3253H322.877C330.344 17.3253 336.41 23.3712 336.41 30.8123V28.487C336.477 21.0459 330.41 15 322.877 15Z",
    fill: "#B5B8BA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M153.847 50.8189C153.847 51.9469 154.069 52.8169 154.513 53.4289C154.969 54.0289 155.665 54.3289 156.601 54.3289C157.009 54.3289 157.411 54.2809 157.807 54.1849C158.203 54.0889 158.677 53.9209 159.229 53.6809L159.751 55.0129C159.163 55.2769 158.605 55.4689 158.077 55.5889C157.549 55.7089 157.039 55.7689 156.547 55.7689C155.131 55.7689 154.057 55.3249 153.325 54.4369C152.593 53.5489 152.227 52.3429 152.227 50.8189V48.1189C152.227 46.5949 152.593 45.3889 153.325 44.5009C154.057 43.6129 155.131 43.1689 156.547 43.1689C157.039 43.1689 157.549 43.2289 158.077 43.3489C158.617 43.4689 159.163 43.6609 159.715 43.9249L159.211 45.2749C158.239 44.8429 157.369 44.6269 156.601 44.6269C155.665 44.6269 154.969 44.9269 154.513 45.5269C154.069 46.1269 153.847 46.9909 153.847 48.1189V50.8189ZM166.246 47.9749C165.706 47.9749 165.178 48.0709 164.662 48.2629C164.158 48.4549 163.618 48.8209 163.042 49.3609V55.5889H161.566V46.6789H162.97V48.1189C163.582 47.5189 164.14 47.0989 164.644 46.8589C165.16 46.6189 165.694 46.4989 166.246 46.4989V47.9749ZM174.638 55.0669C174.098 55.3309 173.558 55.5109 173.018 55.6069C172.478 55.7149 171.98 55.7689 171.524 55.7689C170.24 55.7689 169.28 55.4029 168.644 54.6709C168.02 53.9389 167.708 52.9369 167.708 51.6649V50.5849C167.708 49.3489 168.02 48.3589 168.644 47.6149C169.28 46.8709 170.174 46.4989 171.326 46.4989C171.938 46.4989 172.496 46.6249 173 46.8769C173.516 47.1169 173.924 47.4889 174.224 47.9929C174.536 48.4849 174.692 49.1209 174.692 49.9009C174.692 50.4049 174.62 50.9809 174.476 51.6289H169.166V51.6649C169.166 52.5769 169.352 53.2669 169.724 53.7349C170.108 54.2029 170.72 54.4369 171.56 54.4369C171.944 54.4369 172.364 54.3889 172.82 54.2929C173.288 54.1969 173.744 54.0469 174.188 53.8429L174.638 55.0669ZM171.326 47.7949C170.63 47.7949 170.102 48.0229 169.742 48.4789C169.394 48.9229 169.202 49.5529 169.166 50.3689H173.198C173.234 50.1529 173.252 49.9489 173.252 49.7569C173.252 49.0849 173.06 48.5929 172.676 48.2809C172.304 47.9569 171.854 47.7949 171.326 47.7949ZM183.762 55.6789C183.21 55.6789 182.766 55.5529 182.43 55.3009C182.106 55.0489 181.878 54.7369 181.746 54.3649C181.158 54.8809 180.624 55.2469 180.144 55.4629C179.664 55.6669 179.184 55.7689 178.704 55.7689C177.924 55.7689 177.348 55.5169 176.976 55.0129C176.604 54.5089 176.418 53.8909 176.418 53.1589C176.418 52.6669 176.508 52.2289 176.688 51.8449C176.868 51.4609 177.174 51.1609 177.606 50.9449C178.038 50.7169 178.62 50.6029 179.352 50.6029C179.676 50.6029 180.03 50.6269 180.414 50.6749C180.798 50.7109 181.188 50.7589 181.584 50.8189V49.6129C181.584 48.9409 181.434 48.4849 181.134 48.2449C180.846 47.9929 180.42 47.8669 179.856 47.8669C179.088 47.8669 178.23 48.0769 177.282 48.4969L176.814 47.2729C177.366 47.0209 177.894 46.8289 178.398 46.6969C178.902 46.5649 179.412 46.4989 179.928 46.4989C180.768 46.4989 181.41 46.6369 181.854 46.9129C182.298 47.1889 182.604 47.5549 182.772 48.0109C182.94 48.4669 183.024 48.9649 183.024 49.5049V53.3569C183.024 53.6329 183.078 53.8669 183.186 54.0589C183.294 54.2389 183.51 54.3289 183.834 54.3289H184.032V55.6789H183.762ZM177.876 53.1409C177.876 53.5489 177.972 53.8789 178.164 54.1309C178.356 54.3829 178.632 54.5089 178.992 54.5089C179.304 54.5089 179.664 54.4189 180.072 54.2389C180.48 54.0469 180.984 53.6689 181.584 53.1049V51.9709C180.768 51.8389 180.048 51.7729 179.424 51.7729C178.872 51.7729 178.476 51.8869 178.236 52.1149C177.996 52.3429 177.876 52.6849 177.876 53.1409ZM191.019 55.2649C190.347 55.6009 189.633 55.7689 188.877 55.7689C188.229 55.7689 187.719 55.6369 187.347 55.3729C186.987 55.1089 186.729 54.7549 186.573 54.3109C186.429 53.8669 186.357 53.3749 186.357 52.8349V47.9749H184.809V46.6789H186.357V44.1949H187.833V46.6789H190.749V47.9749H187.833V52.7809C187.833 53.4049 187.935 53.8369 188.139 54.0769C188.355 54.3049 188.685 54.4189 189.129 54.4189C189.345 54.4189 189.567 54.3949 189.795 54.3469C190.035 54.2869 190.293 54.1909 190.569 54.0589L191.019 55.2649ZM199.423 55.0669C198.883 55.3309 198.343 55.5109 197.803 55.6069C197.263 55.7149 196.765 55.7689 196.309 55.7689C195.025 55.7689 194.065 55.4029 193.429 54.6709C192.805 53.9389 192.493 52.9369 192.493 51.6649V50.5849C192.493 49.3489 192.805 48.3589 193.429 47.6149C194.065 46.8709 194.959 46.4989 196.111 46.4989C196.723 46.4989 197.281 46.6249 197.785 46.8769C198.301 47.1169 198.709 47.4889 199.009 47.9929C199.321 48.4849 199.477 49.1209 199.477 49.9009C199.477 50.4049 199.405 50.9809 199.261 51.6289H193.951V51.6649C193.951 52.5769 194.137 53.2669 194.509 53.7349C194.893 54.2029 195.505 54.4369 196.345 54.4369C196.729 54.4369 197.149 54.3889 197.605 54.2929C198.073 54.1969 198.529 54.0469 198.973 53.8429L199.423 55.0669ZM196.111 47.7949C195.415 47.7949 194.887 48.0229 194.527 48.4789C194.179 48.9229 193.987 49.5529 193.951 50.3689H197.983C198.019 50.1529 198.037 49.9489 198.037 49.7569C198.037 49.0849 197.845 48.5929 197.461 48.2809C197.089 47.9569 196.639 47.7949 196.111 47.7949ZM213.115 54.1309V55.5889H206.275V43.3489H212.935V44.8249H207.841V48.6589H212.395V50.1349H207.841V54.1309H213.115ZM221.924 46.6789L218.774 55.5889H217.388L214.202 46.6789H215.732L217.226 51.0169L218.126 53.7349L219.008 51.0169L220.466 46.6789H221.924ZM230.185 55.0669C229.645 55.3309 229.105 55.5109 228.565 55.6069C228.025 55.7149 227.527 55.7689 227.071 55.7689C225.787 55.7689 224.827 55.4029 224.191 54.6709C223.567 53.9389 223.255 52.9369 223.255 51.6649V50.5849C223.255 49.3489 223.567 48.3589 224.191 47.6149C224.827 46.8709 225.721 46.4989 226.873 46.4989C227.485 46.4989 228.043 46.6249 228.547 46.8769C229.063 47.1169 229.471 47.4889 229.771 47.9929C230.083 48.4849 230.239 49.1209 230.239 49.9009C230.239 50.4049 230.167 50.9809 230.023 51.6289H224.713V51.6649C224.713 52.5769 224.899 53.2669 225.271 53.7349C225.655 54.2029 226.267 54.4369 227.107 54.4369C227.491 54.4369 227.911 54.3889 228.367 54.2929C228.835 54.1969 229.291 54.0469 229.735 53.8429L230.185 55.0669ZM226.873 47.7949C226.177 47.7949 225.649 48.0229 225.289 48.4789C224.941 48.9229 224.749 49.5529 224.713 50.3689H228.745C228.781 50.1529 228.799 49.9489 228.799 49.7569C228.799 49.0849 228.607 48.5929 228.223 48.2809C227.851 47.9569 227.401 47.7949 226.873 47.7949ZM237.077 47.8849C236.741 47.8849 236.345 47.9689 235.889 48.1369C235.445 48.3049 234.905 48.6469 234.269 49.1629V55.5889H232.793V46.6789H234.197V47.9209C234.833 47.3809 235.409 47.0089 235.925 46.8049C236.453 46.6009 236.957 46.4989 237.437 46.4989C238.265 46.4989 238.895 46.7629 239.327 47.2909C239.771 47.8069 239.993 48.5449 239.993 49.5049V55.5889H238.517V49.7209C238.517 48.4969 238.037 47.8849 237.077 47.8849ZM247.972 55.2649C247.3 55.6009 246.586 55.7689 245.83 55.7689C245.182 55.7689 244.672 55.6369 244.3 55.3729C243.94 55.1089 243.682 54.7549 243.526 54.3109C243.382 53.8669 243.31 53.3749 243.31 52.8349V47.9749H241.762V46.6789H243.31V44.1949H244.786V46.6789H247.702V47.9749H244.786V52.7809C244.786 53.4049 244.888 53.8369 245.092 54.0769C245.308 54.3049 245.638 54.4189 246.082 54.4189C246.298 54.4189 246.52 54.3949 246.748 54.3469C246.988 54.2869 247.246 54.1909 247.522 54.0589L247.972 55.2649ZM252.092 54.4549C253.292 54.4549 253.892 54.0469 253.892 53.2309C253.892 52.8829 253.784 52.6069 253.568 52.4029C253.352 52.1989 252.956 52.0249 252.38 51.8809L251.39 51.6289C250.658 51.4489 250.112 51.1369 249.752 50.6929C249.392 50.2369 249.212 49.6969 249.212 49.0729C249.212 48.6169 249.314 48.1969 249.518 47.8129C249.722 47.4169 250.046 47.0989 250.49 46.8589C250.934 46.6189 251.51 46.4989 252.218 46.4989C252.674 46.4989 253.136 46.5529 253.604 46.6609C254.084 46.7569 254.57 46.9249 255.062 47.1649L254.594 48.4069C253.718 48.0109 252.926 47.8129 252.218 47.8129C251.174 47.8129 250.652 48.2029 250.652 48.9829C250.652 49.2829 250.748 49.5409 250.94 49.7569C251.132 49.9729 251.492 50.1469 252.02 50.2789L253.01 50.5309C253.802 50.7229 254.384 51.0349 254.756 51.4669C255.128 51.8989 255.314 52.4569 255.314 53.1409C255.314 53.6329 255.206 54.0829 254.99 54.4909C254.786 54.8869 254.45 55.1989 253.982 55.4269C253.526 55.6549 252.908 55.7689 252.128 55.7689C251.612 55.7689 251.096 55.7149 250.58 55.6069C250.076 55.4989 249.554 55.3249 249.014 55.0849L249.41 53.8609C249.926 54.0649 250.394 54.2149 250.814 54.3109C251.234 54.4069 251.66 54.4549 252.092 54.4549Z",
    fill: "#005492"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M161.447 74.1778L98.0981 71.6309L94.5105 160.255L157.86 162.802L161.447 74.1778Z",
    fill: "#CDD0D1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M160.515 73.1808L97.1655 70.6338L93.5777 159.258L156.927 161.805L160.515 73.1808Z",
    fill: "#4BC5F3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M152.387 77.6811L104.892 75.7715L104.37 88.6502L151.866 90.5598L152.387 77.6811Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M151.732 93.7553L104.237 91.8457L104.094 95.3641L151.59 97.2737L151.732 93.7553Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M124.824 149.278L124.682 152.797L149.329 153.788L149.471 150.27L124.824 149.278Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M125.03 144.478L124.888 147.996L149.535 148.987L149.677 145.469L125.03 144.478Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M117.744 141.831C117.744 141.565 117.744 141.366 117.677 141.167C117.677 141.1 117.677 140.967 117.677 140.901C117.677 140.768 117.677 140.635 117.61 140.502C117.61 140.369 117.61 140.303 117.544 140.17C117.544 140.037 117.544 139.971 117.477 139.838C117.477 139.705 117.41 139.572 117.41 139.439C117.41 139.373 117.41 139.24 117.344 139.173C117.344 139.041 117.277 138.908 117.277 138.775C117.277 138.708 117.277 138.642 117.21 138.575C117.21 138.443 117.144 138.243 117.144 138.11C117.144 138.044 117.144 137.978 117.077 137.911C117.01 137.778 117.01 137.579 116.944 137.446C116.944 137.38 116.944 137.313 116.877 137.313C116.81 137.114 116.81 136.981 116.744 136.782C116.744 136.715 116.744 136.715 116.677 136.649C116.61 136.449 116.61 136.317 116.544 136.117C116.544 136.051 116.544 136.051 116.544 135.984C116.477 135.785 116.41 135.652 116.41 135.453V135.386C116.344 135.187 116.277 134.988 116.21 134.855V134.788C116.144 134.589 116.077 134.39 116.01 134.191C116.01 134.191 116.01 134.191 116.01 134.124C115.944 133.925 115.877 133.725 115.81 133.526C115.744 133.327 115.677 133.128 115.544 132.928C115.477 132.729 115.344 132.53 115.277 132.33C115.21 132.131 115.077 131.932 115.01 131.732C114.944 131.599 114.877 131.533 114.877 131.4C114.944 131.334 115.01 131.267 115.144 131.267C115.41 131.068 115.677 130.802 115.81 130.536C115.877 130.47 115.877 130.404 115.877 130.404L116.41 129.473L118.144 126.284L108.944 125.886L108.144 128.61C108.077 128.875 108.01 129.208 108.01 129.54C108.01 129.673 108.01 129.806 108.077 129.938C108.077 130.071 108.144 130.271 108.21 130.404C108.344 130.802 108.544 131.068 108.877 131.334C108.944 131.334 108.944 131.4 109.01 131.4C109.01 131.4 109.077 131.467 109.144 131.467C109.21 131.467 109.21 131.533 109.277 131.533C109.344 131.533 109.344 131.599 109.41 131.599C109.477 131.599 109.477 131.599 109.544 131.666H109.61H109.677H109.744C109.744 131.666 109.744 131.666 109.81 131.666L109.144 147.943L110.944 148.01H111.077H111.344L110.877 159.836L114.277 159.969L114.744 148.076L115.277 148.01C115.544 147.943 115.877 147.877 116.144 147.744C116.21 147.744 116.21 147.678 116.277 147.678C116.344 147.611 116.477 147.611 116.544 147.545C116.61 147.545 116.61 147.478 116.677 147.478C117.344 147.013 117.877 146.216 117.944 145.419C117.944 145.352 117.944 145.352 117.944 145.286C117.944 145.153 117.944 145.02 117.944 144.821L117.744 141.831Z",
    fill: "#5B5B5E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.21 111.601C127.943 111.535 127.81 111.203 127.877 110.937C127.943 110.671 128.277 110.538 128.543 110.605L129.543 110.937L129.943 109.741L128.943 109.409C128.677 109.342 128.543 109.01 128.61 108.745C128.677 108.479 129.01 108.346 129.277 108.412L130.277 108.745L130.343 108.612C131.277 105.622 129.61 102.433 126.61 101.503L117.543 98.7123C114.543 97.7822 111.343 99.4432 110.41 102.433L110.343 102.566L111.343 102.898C111.61 102.964 111.743 103.297 111.677 103.562C111.61 103.828 111.277 103.961 111.01 103.895L110.01 103.562L109.61 104.758L110.61 105.09C110.877 105.157 111.01 105.489 110.943 105.755C110.877 106.021 110.543 106.153 110.277 106.087L109.277 105.755L108.877 106.951L109.877 107.283C110.143 107.349 110.277 107.682 110.21 107.947C110.143 108.213 109.81 108.346 109.543 108.279L108.543 107.947L108.143 109.143L109.143 109.475C109.41 109.542 109.543 109.874 109.477 110.14C109.41 110.405 109.077 110.538 108.81 110.472L107.81 110.14L107.41 111.336L108.41 111.668C108.677 111.734 108.81 112.066 108.743 112.332C108.677 112.598 108.343 112.731 108.077 112.664L107.077 112.332L106.677 113.528L107.677 113.86C107.943 113.927 108.077 114.259 108.01 114.525C107.943 114.79 107.61 114.923 107.343 114.857L106.343 114.525L105.943 115.721L106.943 116.053C107.21 116.119 107.343 116.451 107.277 116.717C107.21 116.983 106.877 117.116 106.61 117.049L105.61 116.717L105.21 117.913L106.21 118.245C106.477 118.312 106.61 118.644 106.543 118.91C106.477 119.175 106.143 119.308 105.877 119.242L104.877 118.91L104.81 119.042C103.877 122.032 105.543 125.221 108.543 126.151L117.543 128.942C120.543 129.872 123.743 128.211 124.677 125.221L124.743 125.088L123.743 124.756C123.477 124.69 123.343 124.358 123.41 124.092C123.477 123.826 123.81 123.693 124.077 123.76L125.077 124.092L125.477 122.896L124.477 122.564C124.21 122.497 124.077 122.165 124.143 121.899C124.21 121.634 124.543 121.501 124.81 121.567L125.81 121.899L126.21 120.703L125.21 120.371C124.943 120.305 124.81 119.973 124.877 119.707C124.943 119.441 125.277 119.308 125.543 119.375L126.543 119.707L126.943 118.511L125.943 118.179C125.677 118.112 125.543 117.78 125.61 117.514C125.677 117.249 126.01 117.116 126.277 117.182L127.277 117.514L127.677 116.319L126.877 115.986C126.61 115.92 126.477 115.588 126.543 115.322C126.61 115.056 126.943 114.923 127.21 114.99L128.21 115.322L128.61 114.126L127.61 113.794C127.343 113.727 127.21 113.395 127.277 113.129C127.343 112.864 127.677 112.731 127.943 112.797L128.943 113.129L129.343 111.934L128.21 111.601Z",
    fill: "#5B5B5E"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M234.903 78.817L171.561 81.4805L175.312 170.096L238.655 167.432L234.903 78.817Z",
    fill: "#CDD0D1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M234.036 77.8128L170.693 80.4824L174.437 169.098L237.779 166.429L234.036 77.8128Z",
    fill: "#4BC5F3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M234.036 77.8128L170.693 80.4824L174.437 169.098L237.779 166.429L234.036 77.8128Z",
    fill: "#4BC5F3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M226.247 82.9708L178.757 84.9678L179.302 97.8452L226.793 95.8483L226.247 82.9708Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M226.978 99.0422L179.487 101.039L179.636 104.557L227.127 102.56L226.978 99.0422Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M220.385 158.888L191.145 160.117L191.293 163.635L220.534 162.406L220.385 158.888Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M220.186 154.103L190.945 155.333L191.094 158.851L220.335 157.622L220.186 154.103Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M224.877 131.799L218.41 114.392L218.677 113.861L216.744 109.011L215.944 108.546L212.677 110.008L214.544 111.071L213.944 114.592L210.077 116.386L210.61 113.064L208.677 111.801L204.544 113.662L206.544 115.057L205.944 118.246L203.277 119.442L202.144 119.973L202.744 116.917L200.744 115.323L196.744 117.116L198.81 118.645L198.144 121.834L194.544 123.495L195.144 120.239L193.21 118.777L189.077 120.638L191.21 122.166L190.544 125.355L186.944 127.016L187.544 123.76L185.544 122.232L184.344 122.764L185.81 127.946L187.144 128.743L192.544 146.615V146.682L193.544 146.881L223.277 135.121C224.744 134.457 225.344 133.062 224.877 131.799ZM219.877 123.627C219.944 123.76 219.877 123.96 219.744 124.026L200.477 132.597C200.41 132.597 200.41 132.597 200.344 132.597C200.21 132.597 200.077 132.53 200.077 132.397C200.01 132.264 200.077 132.065 200.21 131.999L219.477 123.428C219.677 123.428 219.81 123.495 219.877 123.627ZM218.677 120.571C218.744 120.704 218.677 120.903 218.544 120.97L199.277 129.54C199.21 129.54 199.21 129.54 199.144 129.54C199.01 129.54 198.877 129.474 198.877 129.341C198.81 129.208 198.877 129.009 199.01 128.942L218.277 120.372C218.477 120.372 218.61 120.438 218.677 120.571ZM197.81 125.953L217.077 117.382C217.21 117.316 217.41 117.382 217.477 117.515C217.544 117.648 217.477 117.847 217.344 117.914L198.077 126.484C198.01 126.484 198.01 126.484 197.944 126.484C197.81 126.484 197.677 126.418 197.677 126.285C197.61 126.218 197.677 126.019 197.81 125.953ZM221.344 128.079L221.21 128.145C221.21 128.145 221.21 128.145 221.144 128.212L219.61 128.876L211.744 132.264L213.61 137.38C213.677 137.513 213.61 137.712 213.41 137.779H213.344C213.21 137.779 213.077 137.712 213.077 137.579L211.277 132.464L202.077 136.45L203.877 141.433C203.944 141.566 203.877 141.765 203.677 141.832H203.61C203.477 141.832 203.344 141.765 203.344 141.632L201.544 136.649L193.21 140.237C193.144 140.237 193.144 140.237 193.077 140.237C192.944 140.237 192.81 140.171 192.81 140.038C192.744 139.905 192.81 139.705 192.944 139.639L221.21 127.414C221.344 127.348 221.544 127.414 221.61 127.547C221.544 127.879 221.477 128.012 221.344 128.079Z",
    fill: "#5B5B5E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M315.983 73.6139L252.64 70.8828L248.793 159.498L312.136 162.229L315.983 73.6139Z",
    fill: "#CDD0D1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M315.05 72.6168L251.708 69.8857L247.86 158.501L311.203 161.232L315.05 72.6168Z",
    fill: "#4BC5F3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M306.946 77.0906L259.456 75.043L258.897 87.9204L306.387 89.968L306.946 77.0906Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M306.211 93.1629L258.72 91.1152L258.567 94.6333L306.058 96.6809L306.211 93.1629Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M285.35 151.903L256.11 150.643L255.957 154.161L285.197 155.421L285.35 151.903Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M299.144 143.225C299.21 143.159 299.21 143.159 299.277 143.092C299.543 142.827 299.81 142.561 300.077 142.229C300.077 142.229 300.077 142.229 300.144 142.162C300.277 142.029 300.41 141.896 300.477 141.764C306.21 135.253 304.41 128.343 297.21 126.549C289.943 124.689 293.143 123.559 289.077 119.573C286.143 116.716 282.41 118.444 280.543 119.706L270.61 108.146L271.077 107.747C271.21 107.614 271.21 107.415 271.143 107.282L269.81 105.754C270.277 105.422 271.01 105.82 271.343 105.555C271.61 105.355 271.41 104.89 271.277 104.625C271.277 104.558 271.21 104.492 271.143 104.492L271.01 104.359C270.943 104.292 270.943 104.292 270.877 104.226C270.677 104.093 270.277 103.827 270.01 104.027C269.677 104.292 269.943 105.09 269.61 105.488L267.877 103.429C268.343 103.096 269.077 103.495 269.41 103.229C269.677 103.03 269.477 102.565 269.343 102.299C269.343 102.233 269.277 102.166 269.21 102.166L269.077 102.033C269.01 101.967 269.01 101.967 268.943 101.901C268.743 101.768 268.343 101.502 268.077 101.701C267.743 101.967 268.01 102.764 267.677 103.163L265.943 101.103C266.41 100.771 267.143 101.17 267.477 100.904C267.743 100.705 267.543 100.24 267.41 99.9738C267.41 99.9074 267.343 99.841 267.277 99.841L267.143 99.7081C267.077 99.6416 267.077 99.6417 267.01 99.5752C266.81 99.4423 266.41 99.1766 266.143 99.3759C265.81 99.6416 266.077 100.439 265.743 100.838L264.477 99.3759C264.343 99.243 264.143 99.243 264.01 99.3095L263.81 99.4423C263.677 99.5752 263.477 99.5752 263.343 99.3759L263.01 98.9773C262.877 98.8444 262.677 98.8444 262.543 98.9108L259.143 101.834C259.01 101.967 259.01 102.166 259.077 102.299L259.41 102.698C259.543 102.831 259.543 103.03 259.343 103.163L259.143 103.296C259.01 103.429 259.01 103.628 259.077 103.761L260.343 105.222C259.877 105.555 259.143 105.156 258.81 105.422C258.543 105.621 258.743 106.086 258.877 106.352C258.877 106.418 258.943 106.485 259.01 106.485L259.143 106.618C259.21 106.684 259.21 106.684 259.277 106.751C259.477 106.883 259.877 107.149 260.143 106.95C260.477 106.684 260.21 105.887 260.543 105.488L260.343 105.289L262.277 107.548C261.81 107.88 261.077 107.481 260.743 107.747C260.477 107.946 260.677 108.412 260.81 108.677C260.81 108.744 260.877 108.81 260.943 108.81L261.077 108.943C261.143 109.009 261.143 109.009 261.21 109.076C261.41 109.209 261.81 109.475 262.077 109.275C262.41 109.009 262.143 108.212 262.477 107.814L262.41 107.747L264.41 110.072L264.21 109.873C263.743 110.205 263.01 109.807 262.677 110.072C262.41 110.272 262.61 110.737 262.743 111.003C262.743 111.069 262.81 111.135 262.877 111.135L263.01 111.268C263.077 111.335 263.077 111.335 263.143 111.401C263.343 111.534 263.743 111.8 264.01 111.601C264.343 111.335 264.077 110.538 264.41 110.139L265.743 111.667C265.877 111.8 266.077 111.8 266.21 111.733L267.343 110.803L266.61 111.401L276.543 122.895C275.477 124.025 273.877 126.151 273.943 128.542C273.943 128.609 273.943 128.675 273.943 128.675C273.943 128.742 273.943 128.808 273.943 128.808C273.943 128.808 273.943 128.808 273.943 128.875C273.943 129.007 274.01 129.207 274.01 129.34V129.406C274.01 129.472 274.01 129.472 274.01 129.539V129.605C274.01 129.672 274.01 129.672 274.01 129.738V129.805V129.871C274.01 129.938 274.01 129.938 274.077 130.004V130.07C274.077 130.137 274.143 130.203 274.143 130.27C274.143 130.27 274.143 130.27 274.143 130.336C274.143 130.403 274.21 130.469 274.21 130.469C274.21 130.469 274.21 130.535 274.277 130.535C274.277 130.602 274.343 130.602 274.343 130.668C274.343 130.668 274.343 130.735 274.41 130.735C274.41 130.801 274.477 130.801 274.477 130.868C274.477 130.868 274.477 130.934 274.543 130.934C274.543 131.001 274.61 131.001 274.61 131.067C274.61 131.067 274.61 131.133 274.677 131.133C274.743 131.2 274.743 131.266 274.81 131.333C275.677 132.462 276.41 133.127 277.01 133.658C277.077 133.725 277.143 133.791 277.277 133.857C277.41 133.99 277.61 134.057 277.743 134.19C277.877 134.256 278.01 134.389 278.143 134.455L278.21 134.522C279.41 135.319 280.143 136.183 280.543 140.435C281.277 147.677 287.477 150.467 294.61 146.281C295.61 145.683 296.677 144.953 297.677 144.022L297.877 143.823C298.01 143.69 298.21 143.557 298.343 143.425C298.41 143.358 298.41 143.358 298.477 143.292C298.944 143.425 299.01 143.358 299.144 143.225ZM263.81 101.435C263.943 101.303 264.21 101.303 264.343 101.502L269.343 107.282C269.477 107.415 269.477 107.681 269.277 107.814L263.81 101.435L263.477 101.768L268.943 108.146L268.677 108.345L263.21 101.967L262.877 102.233L268.343 108.611C268.277 108.677 268.21 108.677 268.077 108.677L262.743 102.432C262.743 102.366 262.81 102.233 262.877 102.166L263.81 101.435ZM262.41 102.831L267.743 109.009C267.743 109.142 267.677 109.209 267.61 109.275L262.143 102.897L261.877 103.096L262.143 102.831C262.21 102.831 262.343 102.831 262.41 102.831ZM267.277 109.541L267.01 109.74L261.543 103.362L261.81 103.163L267.277 109.541ZM266.677 110.072C266.543 110.205 266.277 110.205 266.143 110.006L261.143 104.226C261.01 104.093 261.01 103.827 261.21 103.694L266.677 110.072Z",
    fill: "#5B5B5E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M149.81 286.666C168.919 286.666 184.41 284.048 184.41 280.819C184.41 277.59 168.919 274.973 149.81 274.973C130.701 274.973 115.21 277.59 115.21 280.819C115.21 284.048 130.701 286.666 149.81 286.666Z",
    fill: "#D6E3EF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M150.21 275.438C150.144 275.637 149.544 279.424 149.877 281.417C150.277 283.41 155.877 283.277 160.877 283.277C165.877 283.277 171.01 281.882 171.01 280.886C171.01 277.896 163.744 277.232 160.544 275.039C159.077 273.91 151.01 273.644 150.21 275.438Z",
    fill: "url(#paint0_linear_961_905)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M133.41 273.777C133.21 273.843 132.61 277.497 132.81 279.823C133.01 282.148 148.677 281.484 149.477 279.092C150.01 277.497 146.21 276.036 143.744 274.242C141.344 272.581 136.61 272.448 133.41 273.777Z",
    fill: "url(#paint1_linear_961_905)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M132.077 177.773H166.143C167.543 190.197 165.21 224.612 164.743 232.917C164.277 241.554 162.21 274.574 162.21 274.574C157.877 278.029 149.077 275.039 149.077 275.039C148.677 273.578 150.41 245.541 150.543 238.764C150.677 231.987 148.21 210.727 148.21 210.727C148.21 210.727 145.61 234.91 145.343 242.551C145.077 250.191 144.61 273.843 144.61 273.843C139.677 277.032 132.477 274.574 132.477 274.574C132.277 273.578 132.677 240.425 132.81 235.708C132.877 231.057 128.41 190.995 132.077 177.773Z",
    fill: "url(#paint2_linear_961_905)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M146.277 229.794C147.077 220.626 148.143 210.793 148.143 210.793C148.143 210.793 147.543 203.485 146.877 201.957C146.277 200.362 142.41 199.033 140.743 195.911C139.143 192.722 146.41 221.357 146.277 229.794Z",
    fill: "url(#paint3_linear_961_905)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M145.077 114.923C146.61 112.597 148.077 110.538 148.143 105.422C148.21 100.24 146.81 93.4631 151.41 91.2707C156.21 89.0118 162.21 92.2008 162.343 96.7186C162.543 101.17 160.543 108.279 160.077 109.741C159.743 110.87 157.877 111.667 157.877 111.667C157.877 111.667 157.21 115.454 157.543 116.384C157.543 116.318 152.477 119.308 145.077 114.923Z",
    fill: "url(#paint4_linear_961_905)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M164.01 92.5331C164.01 92.5331 164.81 95.7221 163.21 96.7187C161.81 97.6488 161.943 99.1769 161.077 101.303C160.543 98.8447 158.877 100.705 159.41 103.296C159.81 105.356 156.877 107.017 156.077 107.615C154.01 109.076 152.077 107.548 150.877 107.349C149.677 107.15 148.077 107.548 148.077 107.548C148.077 107.548 148.077 103.628 147.41 101.037C146.677 98.4461 146.077 92.3338 150.543 89.7427C154.277 87.5502 159.477 89.6098 161.277 91.4036C162.943 93.131 163.743 93.0646 164.01 92.5331Z",
    fill: "url(#paint5_linear_961_905)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M160.143 109.674C160.21 109.475 160.276 109.276 160.343 108.943C160.343 108.943 158.876 110.936 158.943 106.086C158.943 105.954 158.21 109.674 157.876 111.601C157.876 111.601 159.743 110.804 160.143 109.674Z",
    fill: "url(#paint6_linear_961_905)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M173.01 111.601C174.344 109.94 179.877 105.489 180.41 105.09C180.41 105.09 177.544 102.698 173.944 101.702C170.81 100.838 161.677 100.173 160.677 100.373C159.744 100.572 157.077 103.495 155.877 104.093C154.744 104.691 152.077 104.492 151.344 104.359C150.477 104.226 149.144 103.429 148.877 102.897C148.677 102.432 149.077 101.768 150.21 102.1C151.344 102.432 153.01 102.3 154.01 101.768C155.01 101.237 151.277 100.639 149.477 100.771C147.81 100.904 147.077 100.904 146.477 100.572C146.01 100.306 145.544 99.5091 146.677 99.1105C147.744 98.7118 150.144 98.4461 150.144 98.2468C150.144 98.0475 147.477 98.5125 146.61 98.4461C145.877 98.3797 145.21 97.2502 146.277 96.7187C147.41 96.1207 149.744 95.9879 149.677 95.7886C149.61 95.5892 146.744 96.2536 146.21 95.9214C145.61 95.5228 145.544 94.5262 146.744 94.2605C147.944 93.9947 149.41 93.6625 149.477 93.5296C149.544 93.3968 147.744 93.9947 147.077 93.8618C146.61 93.729 146.077 92.6659 147.677 92.2009C149.277 91.7358 152.277 91.1379 154.21 91.2043C156.877 91.2707 158.744 92.1344 159.744 92.9317C160.744 93.729 161.277 93.5961 163.277 93.8618C165.277 94.1276 171.477 94.4598 176.877 95.3235C183.677 96.3865 191.81 98.5125 192.61 101.436C193.61 105.156 182.41 118.245 178.544 121.899C174.677 125.553 171.677 113.262 173.01 111.601Z",
    fill: "url(#paint7_linear_961_905)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M184.61 106.286C182.077 105.954 180.41 105.09 180.41 105.09C180.077 105.356 178.144 106.884 176.344 108.478C176.544 108.279 176.744 108.146 176.944 107.947C178.144 106.884 187.144 106.618 184.61 106.286Z",
    fill: "url(#paint8_linear_961_905)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M145.077 114.923C145.077 114.923 138.744 116.451 135.21 118.577C131.477 120.902 129.01 129.34 129.344 135.386C129.61 140.435 131.81 166.479 130.077 177.043C131.077 180.83 164.877 180.431 167.744 176.91C165.877 169.07 166.01 141.631 167.477 134.721C168.477 130.004 178.877 123.892 178.877 123.892C178.877 123.892 179.544 112.664 172.744 110.937C168.944 111.667 162.61 116.916 157.544 116.318C152.544 117.78 148.144 116.384 145.077 114.923Z",
    fill: "url(#paint9_linear_961_905)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M401.944 276.435C379.277 279.624 356.144 276.501 355.877 270.92C355.677 267.798 368.21 266.402 377.21 266.004C386.41 265.605 399.744 266.203 407.677 268.263C415.144 270.189 412.677 274.907 401.944 276.435Z",
    fill: "#D6E3EF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M380.677 109.741C376.277 109.276 368.01 110.937 354.277 106.884C345.01 104.16 333.344 97.9149 331.61 97.184C329.877 96.5196 326.944 104.226 328.21 106.153C329.477 108.08 336.81 110.937 349.077 115.92C362.344 121.301 375.01 122.962 380.077 121.5C390.144 118.577 384.144 110.14 380.677 109.741Z",
    fill: "url(#paint10_linear_961_905)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M331.477 97.7155C330.743 96.2538 330.21 95.3901 326.077 93.7292C321.943 92.0018 316.677 89.8093 314.677 89.2778C313.677 89.0121 312.943 90.3408 313.877 91.0052C316.21 92.6662 320.543 94.7258 320.543 94.7258C320.543 94.7258 318.677 99.0443 318.343 101.303C318.21 102.1 318.143 103.097 320.477 104.094C323.677 105.489 327.943 106.153 330.543 104.16C332.81 102.3 332.277 99.31 331.477 97.7155Z",
    fill: "url(#paint11_linear_961_905)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M318.61 95.1245C318.81 94.593 319.21 94.3937 321.077 94.7259C322.943 95.0581 324.743 96.1211 324.343 96.8519C323.943 97.6492 322.877 97.5163 321.41 97.317C320.01 97.1177 318.01 96.5862 318.61 95.1245Z",
    fill: "url(#paint12_linear_961_905)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M318.01 97.0513C318.21 96.5198 318.61 96.3204 320.477 96.6526C322.343 96.9848 324.143 98.0479 323.743 98.7787C323.343 99.5759 322.277 99.4431 320.81 99.2437C319.343 99.0444 317.343 98.5794 318.01 97.0513Z",
    fill: "url(#paint13_linear_961_905)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M317.343 98.978C317.543 98.4465 317.943 98.2472 319.81 98.5794C321.677 98.9116 323.477 99.9746 323.077 100.705C322.677 101.503 321.61 101.37 320.143 101.17C318.743 101.038 316.743 100.506 317.343 98.978Z",
    fill: "url(#paint14_linear_961_905)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M317.344 101.17C317.544 100.705 317.877 100.506 319.61 100.771C321.344 101.104 323.077 102.034 322.677 102.765C322.277 103.495 321.277 103.362 319.944 103.163C318.61 103.03 316.744 102.499 317.344 101.17Z",
    fill: "url(#paint15_linear_961_905)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M325.41 92.4007C324.477 92.0685 322.743 96.7192 321.21 99.2438C321.077 99.4431 322.143 100.174 323.477 99.5096C324.143 99.1774 325.21 98.1144 325.677 97.1842C324.677 101.835 328.543 105.555 330.543 104.094C332.877 102.366 332.81 99.5096 332.077 97.9151C331.277 96.4534 329.943 93.8623 325.41 92.4007Z",
    fill: "url(#paint16_linear_961_905)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M376.41 262.482C376.41 262.482 365.943 266.601 364.21 268.594C362.543 270.587 368.277 271.318 373.143 271.185C378.01 271.052 383.21 269.989 383.41 269.591C383.61 269.192 383.143 263.279 382.81 263.146C382.543 263.013 378.943 260.887 376.41 262.482Z",
    fill: "#2F2B30"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M394.143 265.073C394.143 265.073 383.077 270.388 380.81 272.979C378.477 275.57 388.61 275.438 391.077 275.105C395.01 274.507 401.61 273.644 402.277 273.245C403.01 272.846 402.21 266.933 401.343 266.136C400.477 265.339 395.143 264.741 394.143 265.073Z",
    fill: "#2F2B30"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M392.277 265.871C396.81 268.728 402.21 267.199 402.21 267.199C402.277 265.738 402.477 247.467 401.477 235.508C400.877 228.532 398.477 221.49 398.343 219.098C397.543 201.824 402.077 185.613 400.81 170.665C396.61 170.93 372.21 170.465 367.477 170.665C367.277 172.724 365.81 196.841 367.477 215.51C369.543 238.83 373.543 262.017 373.677 263.213C373.81 264.409 382.477 266.136 383.477 265.073C383.943 260.223 384.21 254.244 383.477 243.016C383.21 238.565 382.677 233.582 382.343 228.665C381.143 210.328 381.677 200.562 381.943 200.828C382.543 201.425 383.943 210.86 384.743 218.5C385.677 226.141 391.077 256.104 392.277 265.871Z",
    fill: "url(#paint17_linear_961_905)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M382.01 200.827C381.81 200.628 381.544 205.212 381.744 214.115C380.877 208.401 378.277 199.964 376.477 194.582C375.344 191.061 380.81 197.439 382.01 200.827Z",
    fill: "url(#paint18_linear_961_905)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M400.41 173.588C402.41 171.728 405.477 120.637 401.277 114.591C399.077 111.468 394.81 109.209 390.61 107.615C384.21 105.223 376.277 108.611 371.477 113.461C368.077 116.916 369.01 129.739 369.477 138.708C370.277 152.461 363.144 169.934 366.277 171.994C369.477 174.053 398.41 175.448 400.41 173.588Z",
    fill: "url(#paint19_linear_961_905)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M398.943 178.571C399.677 179.302 400.21 180.83 400.01 182.956C399.877 185.082 399.677 190.065 399.543 191.593C399.41 193.121 397.743 192.789 397.677 191.659C397.677 190.53 397.61 187.474 397.343 187.54C396.943 187.607 396.943 190.596 396.877 192.058C396.81 193.52 396.943 194.915 395.877 195.048C394.743 195.114 394.477 194.317 394.477 192.988C394.477 191.593 394.943 188.005 394.677 188.005C394.477 188.005 394.41 188.47 393.743 190.729C393.01 193.32 392.943 195.114 391.943 195.513C390.877 195.911 390.21 195.114 390.677 193.453C391.01 192.191 392.477 187.607 392.21 187.474C392.01 187.407 391.143 189.799 390.41 191.46C389.677 193.121 388.877 193.187 388.144 192.789C387.477 192.39 388.343 190.663 388.877 189.334C389.41 188.005 390.477 185.414 390.277 185.082C390.077 184.75 389.277 187.474 388.61 188.072C387.943 188.603 387.077 188.803 386.877 188.271C386.81 188.138 387.544 186.809 387.81 185.348C388.077 184.085 388.677 182.092 389.477 180.099C389.81 179.302 390.943 177.309 392.21 176.91C393.01 176.578 397.41 177.176 398.943 178.571Z",
    fill: "url(#paint20_linear_961_905)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M389.744 175.05C390.344 173.322 395.61 149.405 395.744 144.289C395.944 136.383 386.41 115.72 393.61 111.933C396.944 110.206 400.544 112.398 402.477 116.651C404.744 121.567 407.144 142.561 407.144 147.279C407.144 151.996 403.41 175.515 401.61 178.505C401.01 180.697 388.344 179.103 389.744 175.05Z",
    fill: "url(#paint21_linear_961_905)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M389.077 107.216C389.077 107.216 387.744 103.629 387.81 101.436C387.944 99.2437 389.41 91.1383 386.41 88.7465C383.344 86.3547 375.477 86.554 373.61 90.8061C372.677 92.9985 372.144 94.3273 372.144 95.3239C372.144 96.3205 372.477 96.7191 372.677 98.1143C372.877 99.5095 372.21 107.017 373.677 108.479C374.277 109.143 377.21 108.279 378.277 107.681C378.544 109.807 378.277 112.465 379.944 112.93C381.144 113.262 386.01 111.203 389.077 107.216Z",
    fill: "url(#paint22_linear_961_905)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M387.81 101.768C386.477 101.635 386.544 97.1175 384.61 95.9881C383.61 95.4566 382.41 98.247 382.41 98.247H381.077C381.077 98.247 381.41 96.1209 380.61 95.3901C379.81 94.6593 378.077 94.3271 378.077 93.5963C378.077 92.8655 378.81 90.8723 377.877 90.1415C376.877 89.4107 373.677 90.8059 373.677 90.8059C373.677 90.8059 372.944 89.2113 373.21 88.2148C373.544 87.2846 382.077 84.9593 386.677 87.0189C391.277 89.0785 388.744 99.2435 387.81 101.768Z",
    fill: "url(#paint23_linear_961_905)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M378.744 111.734C378.344 110.671 378.41 109.01 378.21 107.682C378.21 107.682 380.344 106.619 381.544 104.16C382.744 101.702 381.344 105.556 380.344 107.283C379.144 109.409 378.61 110.738 378.744 111.734Z",
    fill: "url(#paint24_linear_961_905)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M385.01 100.506C384.677 101.436 384.21 102.964 382.743 102.898C381.477 102.831 382.21 98.5127 382.21 98.5127C382.21 98.5127 384.61 100.838 385.01 100.506Z",
    fill: "url(#paint25_linear_961_905)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M382.21 99.3761C382.21 99.3761 381.944 95.9877 383.877 95.8549C385.81 95.722 385.477 99.6418 384.877 100.838C384.21 102.034 382.144 102.632 382.21 99.3761Z",
    fill: "url(#paint26_linear_961_905)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2768 278.561C58.9072 278.561 74.0101 275.646 74.0101 272.05C74.0101 268.454 58.9072 265.539 40.2768 265.539C21.6464 265.539 6.54346 268.454 6.54346 272.05C6.54346 275.646 21.6464 278.561 40.2768 278.561Z",
    fill: "#D6E3EF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0769 267.068C48.9436 267.134 48.1436 271.851 48.1436 274.841C48.1436 274.841 49.2102 277.365 53.4102 276.635C57.6102 275.904 64.4102 271.452 65.1436 270.124C66.5436 267.533 64.3436 266.137 62.0102 265.739C58.9436 265.207 50.3436 266.204 49.0769 267.068Z",
    fill: "url(#paint27_linear_961_905)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M33.877 267.068C34.0103 267.134 34.8103 271.851 34.8103 274.841C34.8103 274.841 33.7437 277.365 29.5437 276.635C25.3437 275.904 18.5437 271.452 17.8103 270.124C16.4103 267.533 18.6103 266.137 20.9437 265.739C24.0103 265.207 32.6103 266.204 33.877 267.068Z",
    fill: "url(#paint28_linear_961_905)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8769 230.128C60.6102 220.162 60.7435 177.243 60.1435 174.984C59.5435 172.792 23.4102 172.792 22.8102 174.984C22.2102 177.243 22.2769 220.096 22.0769 230.128C21.8102 240.094 23.6769 266.071 23.6769 266.071C29.1435 271.918 35.0102 267.732 35.0102 267.732C34.6769 264.012 35.0102 233.716 35.6102 226.673C36.2102 219.963 41.0102 197.042 41.4768 194.916C41.9435 197.042 46.7435 219.963 47.3435 226.673C47.9435 233.716 48.2769 264.012 47.9435 267.732C47.9435 267.732 53.8102 271.918 59.2769 266.071C59.2769 266.071 61.1435 240.16 60.8769 230.128Z",
    fill: "url(#paint29_linear_961_905)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4767 117.116C47.2767 115.788 47.0768 113.662 46.9434 112.333C48.6101 112.599 49.7434 112.599 50.4101 111.868C51.4767 110.672 50.6768 106.486 50.6101 103.563C50.5434 100.64 50.8767 96.2547 49.4101 93.265C48.0101 90.4081 36.0767 88.7472 33.2767 95.5239C30.5434 102.101 35.9434 108.081 36.5434 111.735C37.1434 115.389 36.6101 116.585 36.6101 116.585C36.6101 116.585 42.2767 118.91 47.4767 117.116Z",
    fill: "url(#paint30_linear_961_905)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8769 99.7093C46.6102 102.633 47.6102 103.828 47.4102 104.161C46.8769 102.433 46.1436 101.902 45.4769 102.035C44.7436 102.234 44.4102 103.629 44.8102 104.626C45.6102 106.818 44.3436 109.21 43.4102 110.007C42.0769 111.137 38.2769 109.675 36.4769 110.937C35.4769 107.283 30.6102 101.702 32.6769 95.1914C34.9436 88.2154 47.2102 89.8099 49.4102 92.1353C50.3436 93.0654 50.5436 94.9921 50.2102 95.4572C49.4769 95.125 48.5436 95.7894 48.5436 96.8524C48.5436 98.5798 48.1436 99.1113 47.8769 99.7093Z",
    fill: "url(#paint31_linear_961_905)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4104 111.801C50.6104 111.536 50.8104 111.204 50.8771 110.672C50.5438 111.735 49.0771 110.871 48.2104 109.875C47.3438 108.878 47.0104 107.815 46.8771 108.214C46.6771 109.476 46.9438 112.2 46.9438 112.2C48.6105 112.599 49.7438 112.532 50.4104 111.801Z",
    fill: "url(#paint32_linear_961_905)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6102 120.638C22.6102 120.638 1.21022 140.436 0.0768873 148.475C-1.12311 156.581 12.0769 169.138 15.0102 171.463C15.0102 171.463 19.0769 170.068 18.8769 165.085C18.8769 165.085 10.1436 152.927 10.4769 150.07C10.8102 147.279 21.6769 138.908 21.6769 138.908C21.6769 138.908 24.0102 126.219 22.6102 120.638Z",
    fill: "url(#paint33_linear_961_905)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9438 120.97C59.9438 120.97 81.0771 140.436 82.2771 148.542C83.4771 156.647 70.2771 169.204 67.3438 171.529C67.3438 171.529 63.2771 170.134 63.4771 165.151C63.4771 165.151 72.2104 152.993 71.8771 150.136C71.5438 147.346 61.3438 139.174 61.3438 139.174C61.3438 139.174 58.5438 127.547 59.9438 120.97Z",
    fill: "url(#paint34_linear_961_905)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9437 120.969C57.9437 118.578 48.8104 115.92 41.7437 115.588C31.2104 115.056 24.7437 118.246 22.6104 120.704C21.0771 122.498 22.0771 148.674 22.0771 154.986C22.0771 166.214 21.0104 172.393 20.8104 174.452C20.0771 181.362 61.5437 179.701 62.0104 175.25C62.2104 173.124 60.9437 164.221 60.9437 152.926C60.9437 145.352 62.4104 123.826 59.9437 120.969Z",
    fill: "url(#paint35_linear_961_905)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0103 171.529C15.7436 172.326 16.8103 172.659 18.1436 172.459C20.6769 172.061 22.4103 168.938 23.8769 167.344C25.3436 165.749 27.2103 165.749 27.6103 165.616C28.6103 165.35 28.9436 163.689 27.6103 163.623C26.4769 163.557 21.6103 164.354 18.8769 165.218C19.2103 167.144 17.0769 170.533 15.0103 171.529Z",
    fill: "url(#paint36_linear_961_905)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3437 171.529C66.6103 172.326 65.5437 172.659 64.2103 172.459C61.677 172.061 59.9437 168.938 58.477 167.344C57.0103 165.749 55.1437 165.749 54.7437 165.616C53.7437 165.35 53.4103 163.689 54.7437 163.623C55.877 163.557 60.7437 164.354 63.477 165.218C63.077 167.144 65.2103 170.533 67.3437 171.529Z",
    fill: "url(#paint37_linear_961_905)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M261.477 282.016C280.402 282.016 295.743 279.279 295.743 275.903C295.743 272.528 280.402 269.791 261.477 269.791C242.552 269.791 227.21 272.528 227.21 275.903C227.21 279.279 242.552 282.016 261.477 282.016Z",
    fill: "#D6E3EF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M272.343 178.571C272.343 178.571 270.877 179.966 270.743 181.029C270.61 182.092 270.21 186.079 269.143 187.673C269.143 187.673 265.943 179.369 264.677 177.242C265.543 176.246 267.01 177.575 267.743 177.11C268.477 176.645 269.943 174.585 269.943 174.585C269.943 174.585 271.943 177.176 272.343 178.571Z",
    fill: "url(#paint38_linear_961_905)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M230.677 177.376C230.677 177.376 231.943 178.97 231.943 180.033C231.943 181.096 231.877 185.083 232.677 186.876C232.677 186.876 236.877 178.97 238.41 177.11C237.677 175.981 236.077 177.11 235.343 176.579C234.677 176.047 233.477 173.788 233.477 173.788C233.477 173.788 231.21 176.047 230.677 177.376Z",
    fill: "url(#paint39_linear_961_905)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M253.944 272.515C253.477 270.389 253.477 267.2 253.477 267.2C252.277 266.801 248.21 267.731 248.21 267.731C248.21 267.731 248.677 271.12 246.144 271.851C247.61 275.106 254.21 273.777 253.944 272.515Z",
    fill: "url(#paint40_linear_961_905)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M246.21 271.917C245.944 271.983 245.677 271.983 245.344 272.05C243.944 272.183 241.944 272.382 241.21 272.448C237.744 272.914 237.21 274.109 238.477 275.305C239.61 276.435 244.744 278.494 248.744 279.092C251.41 279.491 254.01 279.225 254.344 278.229C254.677 277.232 254.344 273.644 254.077 272.515C252.81 273.91 248.277 274.309 246.21 271.917Z",
    fill: "url(#paint41_linear_961_905)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M270.344 272.515C270.744 270.389 270.744 267.2 270.744 267.2C271.877 266.801 275.744 267.731 275.744 267.731C275.744 267.731 275.277 271.12 277.677 271.851C276.344 275.106 270.077 273.777 270.344 272.515Z",
    fill: "url(#paint42_linear_961_905)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M277.743 271.917C277.943 271.983 278.277 271.983 278.544 272.05C279.877 272.183 281.81 272.382 282.477 272.448C285.81 272.914 286.277 274.109 285.077 275.305C284.01 276.435 279.077 278.494 275.277 279.092C272.744 279.491 270.277 279.225 269.944 278.229C269.61 277.232 269.944 273.644 270.21 272.515C271.41 273.91 275.744 274.309 277.743 271.917Z",
    fill: "url(#paint43_linear_961_905)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M236.81 176.379C236.81 176.379 231.877 184.95 231.21 193.254C230.543 201.559 239.143 229.53 239.81 235.177C240.477 240.824 240.943 247.535 242.877 253.78C244.743 260.091 247.143 268.13 247.61 269.658C247.61 269.658 252.543 271.585 254.41 269.26C254.41 269.26 253.277 252.982 253.01 249.661C252.677 246.339 250.343 236.838 250.143 233.782C249.943 230.726 250.41 200.895 251.077 199.832C251.077 199.832 261.81 231.39 262.41 234.114C263.077 236.838 263.61 242.219 264.477 246.804C265.343 251.388 269.277 267.599 269.343 268.662C269.343 268.662 274.477 270.057 277.143 267.931C277.143 267.931 276.61 250.923 276.477 248.066C276.277 245.209 273.943 235.243 273.477 232.785C272.943 230.327 270.61 194.915 269.743 189.999C268.877 185.082 266.543 178.372 266.543 178.372C266.543 178.372 240.477 176.246 236.81 176.379Z",
    fill: "url(#paint44_linear_961_905)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M287.21 161.696C284.144 156.714 274.744 142.894 271.477 138.443C270.944 137.712 270.21 137.247 269.41 136.915C264.81 135.453 257.077 133.726 253.544 133.859C249.877 133.992 237.61 136.981 235.877 138.576C233.477 140.835 222.077 153.724 218.01 158.773C215.277 162.228 229.344 177.575 229.877 178.24C230.41 178.97 235.81 176.379 235.077 174.785C234.41 173.522 227.944 162.959 227.544 161.431C227.21 160.235 236.677 152.661 238.477 151.332C238.61 152.86 241.41 164.553 241.144 167.211C240.877 169.736 236.01 176.313 234.61 179.037C234.077 180.1 243.077 184.086 252.01 184.352C260.01 184.618 268.01 181.163 267.744 180.233C267.277 178.24 265.41 171.463 265.877 168.075C266.277 165.085 268.61 157.046 270.21 152.993C273.21 156.381 277.744 162.228 277.41 163.092C276.877 164.553 269.144 174.187 268.344 175.383C267.41 176.844 272.477 180.033 273.077 179.435C273.61 178.904 289.477 165.417 287.21 161.696Z",
    fill: "url(#paint45_linear_961_905)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M243.677 111.402C240.21 115.92 240.077 122.83 243.743 127.945C246.743 132.131 240.343 139.107 240.943 144.488C241.543 149.87 248.81 149.006 248.943 154.188C249.143 160.434 257.743 162.693 262.343 156.713C266.877 150.734 267.01 143.359 265.41 139.771C263.81 136.117 260.877 132.064 260.543 128.743C260.21 125.421 262.743 117.514 260.477 113.262C257.01 106.751 248.077 105.622 243.677 111.402Z",
    fill: "url(#paint46_linear_961_905)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M232.477 156.248C234.944 154.122 237.61 151.996 238.477 151.398C238.477 151.398 237.744 147.345 237.677 145.684C237.61 144.023 234.277 154.72 232.477 156.248Z",
    fill: "url(#paint47_linear_961_905)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M273.144 156.713C271.744 154.986 271.41 145.485 271.41 147.478C271.41 149.538 270.21 153.126 270.21 153.126C271.077 154.122 272.144 155.385 273.144 156.713Z",
    fill: "url(#paint48_linear_961_905)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_961_905",
    x1: 160.608,
    y1: 271.145,
    x2: 160.366,
    y2: 285.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1524,
    stopColor: "#231E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49484B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_961_905",
    x1: 141.29,
    y1: 270.474,
    x2: 141.068,
    y2: 283.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1524,
    stopColor: "#231E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49484B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_961_905",
    x1: 150.322,
    y1: 156.933,
    x2: 145.648,
    y2: 259.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0708155,
    stopColor: "#26A2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BC5F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_961_905",
    x1: 145.201,
    y1: 218.115,
    x2: 149.631,
    y2: 296.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0708155,
    stopColor: "#26A2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BC5F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_961_905",
    x1: 157.288,
    y1: 89.3355,
    x2: 150.353,
    y2: 120.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2175,
    stopColor: "#FFD6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_961_905",
    x1: 152.457,
    y1: 106.239,
    x2: 157.715,
    y2: 87.0416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1524,
    stopColor: "#231E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49484B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_961_905",
    x1: 160.89,
    y1: 102.604,
    x2: 159.249,
    y2: 109.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2175,
    stopColor: "#FFD6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_961_905",
    x1: 170.096,
    y1: 88.305,
    x2: 167.244,
    y2: 119.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2175,
    stopColor: "#FFD6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_961_905",
    x1: 176.412,
    y1: 114.994,
    x2: 180.613,
    y2: 107.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2175,
    stopColor: "#FFD6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_961_905",
    x1: 154.116,
    y1: 183.064,
    x2: 154.116,
    y2: 111.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0414372,
    stopColor: "#FF2D3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF625B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_961_905",
    x1: 383.228,
    y1: 103.738,
    x2: 329.848,
    y2: 114.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0414372,
    stopColor: "#FF2D3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF625B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_961_905",
    x1: 310.261,
    y1: 93.4913,
    x2: 338.36,
    y2: 105.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#FFC6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_961_905",
    x1: 315.719,
    y1: 94.5498,
    x2: 322.917,
    y2: 96.5372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#FFC6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_961_905",
    x1: 315.177,
    y1: 96.5112,
    x2: 322.375,
    y2: 98.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#FFC6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_961_905",
    x1: 314.636,
    y1: 98.4725,
    x2: 321.834,
    y2: 100.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#FFC6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_961_905",
    x1: 314.086,
    y1: 100.463,
    x2: 321.284,
    y2: 102.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#FFC6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_961_905",
    x1: 323.502,
    y1: 97.5422,
    x2: 336.978,
    y2: 100.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#FFC6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_961_905",
    x1: 382.189,
    y1: 161.806,
    x2: 386.863,
    y2: 235.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0708155,
    stopColor: "#1E4AAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E6BCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_961_905",
    x1: 380.228,
    y1: 191.096,
    x2: 373.277,
    y2: 267.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0708155,
    stopColor: "#1E4AAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E6BCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_961_905",
    x1: 388.582,
    y1: 175.663,
    x2: 378.766,
    y2: 108.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0414372,
    stopColor: "#FF2D3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF625B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_961_905",
    x1: 400.036,
    y1: 186.15,
    x2: 386.888,
    y2: 186.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4771,
    stopColor: "#FFC4BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6916,
    stopColor: "#FFBFB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853,
    stopColor: "#FFB5AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9878,
    stopColor: "#FFA899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA697"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_961_905",
    x1: 405.755,
    y1: 189.847,
    x2: 395.47,
    y2: 142.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0414372,
    stopColor: "#FF2D3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF625B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_961_905",
    x1: 385.275,
    y1: 112.275,
    x2: 380.902,
    y2: 100.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_961_905",
    x1: 382.602,
    y1: 103.644,
    x2: 380.112,
    y2: 80.1639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.046748,
    stopColor: "#2E0400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    stopColor: "#570900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_961_905",
    x1: 376.893,
    y1: 114.879,
    x2: 380.715,
    y2: 103.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFACA8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_961_905",
    x1: 381.958,
    y1: 104.31,
    x2: 383.648,
    y2: 99.4505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFACA8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_961_905",
    x1: 384.172,
    y1: 93.0638,
    x2: 383.4,
    y2: 105.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2175,
    stopColor: "#FFC6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5908,
    stopColor: "#FFC4BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7587,
    stopColor: "#FFBFB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#FFB5AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9905,
    stopColor: "#FFA899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA697"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_961_905",
    x1: 56.8413,
    y1: 264.604,
    x2: 56.8413,
    y2: 274.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1524,
    stopColor: "#231E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49484B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_961_905",
    x1: 26.1197,
    y1: 264.604,
    x2: 26.1197,
    y2: 274.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1524,
    stopColor: "#231E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49484B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_961_905",
    x1: 41.4804,
    y1: 147.877,
    x2: 41.4804,
    y2: 274.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0708155,
    stopColor: "#26A2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BC5F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_961_905",
    x1: 33.6267,
    y1: 119.044,
    x2: 49.3091,
    y2: 89.4568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2175,
    stopColor: "#FFD6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_961_905",
    x1: 30.7322,
    y1: 117.03,
    x2: 46.4713,
    y2: 87.3359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1524,
    stopColor: "#231E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49484B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_961_905",
    x1: 48.8552,
    y1: 105.867,
    x2: 48.8257,
    y2: 110.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2175,
    stopColor: "#FFD6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_961_905",
    x1: 11.5206,
    y1: 171.425,
    x2: 11.5206,
    y2: 123.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0433645,
    stopColor: "#FFF8CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_961_905",
    x1: 70.9355,
    y1: 171.425,
    x2: 70.9355,
    y2: 123.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0433645,
    stopColor: "#FFF8CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_961_905",
    x1: 41.3681,
    y1: 210.188,
    x2: 41.3681,
    y2: 142.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0433645,
    stopColor: "#FFF8CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_961_905",
    x1: 20.2876,
    y1: 160.968,
    x2: 21.954,
    y2: 169.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2175,
    stopColor: "#FFD6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_961_905",
    x1: 62.0309,
    y1: 160.968,
    x2: 60.3645,
    y2: 169.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2175,
    stopColor: "#FFD6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_961_905",
    x1: 264.609,
    y1: 181.167,
    x2: 272.313,
    y2: 181.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2175,
    stopColor: "#FFD6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_961_905",
    x1: 230.699,
    y1: 180.295,
    x2: 238.503,
    y2: 180.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2175,
    stopColor: "#FFD6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_961_905",
    x1: 250.085,
    y1: 178.517,
    x2: 250.085,
    y2: 255.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2175,
    stopColor: "#FFD6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_961_905",
    x1: 246.111,
    y1: 280.81,
    x2: 246.111,
    y2: 269.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1524,
    stopColor: "#231E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49484B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_961_905",
    x1: 274.014,
    y1: 178.517,
    x2: 274.014,
    y2: 255.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2175,
    stopColor: "#FFD6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_961_905",
    x1: 277.789,
    y1: 280.81,
    x2: 277.789,
    y2: 269.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1524,
    stopColor: "#231E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49484B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_961_905",
    x1: 253.339,
    y1: 172.981,
    x2: 253.65,
    y2: 193.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0433645,
    stopColor: "#FFF8CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_961_905",
    x1: 252.547,
    y1: 190.398,
    x2: 252.547,
    y2: 140.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027897,
    stopColor: "#FCAF19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC456"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_961_905",
    x1: 253.623,
    y1: 157.179,
    x2: 253.623,
    y2: 94.5667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.046748,
    stopColor: "#2E0400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    stopColor: "#570900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_961_905",
    x1: 235.489,
    y1: 159.445,
    x2: 235.489,
    y2: 179.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027897,
    stopColor: "#FCAF19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC456"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_961_905",
    x1: 271.678,
    y1: 159.445,
    x2: 271.678,
    y2: 179.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027897,
    stopColor: "#FCAF19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC456"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateEvents);
export default __webpack_public_path__ + "static/media/create-events.5c40c871c2564516e80794fe3b021011.svg";
export { ForwardRef as ReactComponent };